<template>
    <div class="store-login" id="app">
        <!-- 背景  -->
        <div class="bg-login"></div>
        <div class="login-s">
            <!-- 登录表单 -->
            <el-form :model="loginForm" ref="LoginFormRef" :rules="loginFormRules" label-width="0px" class="login_form">
                <!-- 用户名 -->
                <el-form-item prop="loginName">
                    <el-input v-model="loginForm.loginName" placeholder="请输入账号" prefix-icon="iconfont icon-user"></el-input>
                </el-form-item>
                <!-- 密码 -->
                <el-form-item prop="password">
                    <el-input type="password" placeholder="请输入密码" v-model="loginForm.password" prefix-icon="iconfont icon-3702mima"></el-input>
                </el-form-item>
                <!-- 按钮 -->
                <el-form-item class="btns">
                    <el-button type="primary" @click="login">登录</el-button>
                    <el-button type="info" @click="resetLoginForm">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import {api_prefix} from "../../config/api_url";
export default {
    name: 'Login',
    data() {
        return {
            //数据绑定
            index: 0,
            // bgImages:[
            //     '',
            // ],
            show: {
                diplay: 'blok',
            },
            loginForm: {
                loginName: '',
                password: ''
            },
            //表单验证规则
            loginFormRules: {
                loginName: [{
                    required: true,
                    message: '请输入登录名',
                    trigger: 'blur'
                },
                    {
                        min: 3,
                        max: 20,
                        message: '登录名长度在 3 到 20 个字符',
                        trigger: 'blur'
                    }
                ],
                password: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                },
                    {
                        min: 6,
                        max: 20,
                        message: '密码长度在 6 到 20 个字符',
                        trigger: 'blur'
                    }
                ]
            },
        }
    },
    methods: {
        //添加表单重置方法
        resetLoginForm() {
            //this=>当前组件对象，其中的属性$refs包含了设置的表单ref
            //   console.log(this)
            this.$refs.LoginFormRef.resetFields()
        },
        login() {
            //点击登录的时候先调用validate方法验证表单内容是否有误
            this.$refs.LoginFormRef.validate(async valid => {
                console.log(this.loginFormRules)
                //如果valid参数为true则验证通过
                if (!valid) {
                    return
                }

                let res = null
                let that = this
                let dataObj = qs.stringify(this.loginForm)
                that.$axios({
                    method:"post",
                    url: api_prefix() + "/user/login",
                    data: dataObj,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then (response => {
                    res = response.data
                    console.log(res)
                    if (res.code !== 200) {
                        return this.$message.error(res.msg)
                    }else {
                        //保存token
                        if (response.headers.authorization) {
                            localStorage.setItem('uid', res.data.id)
                            localStorage.setItem('avatar', res.data.avatar)
                            localStorage.setItem('username', res.data.userName)
                            localStorage.setItem('token', response.headers.authorization)
                        }
                        this.$message.success('登录成功')
                        // 导航至/home
                        that.$router.push('/')
                    }
                })
            })
        },
        changBg() {
            // alert(11);
            // const bglogin = document.getElementsByClassName("bg-login");
            // console.log(bglogin);
            if (this.index === 0) {
                this.index = 3;
            } else {
                this.index = this.index - 1;
            }
            // $(".bg-login>li:eq(" + this.index + ")").fadeIn("3000").siblings().fadeOut("3000");
            // console.log(this.index);
        }
    },
    created() {
        // this.index = this.bgImages.length
        setInterval(this.changBg, 7000);
    }
}
</script>
<style type="text/css">
*{
    padding: 0;
    margin: 0;
}
body,html
{
    width: 100%;
    height: 100%;
}

.store-login {
    background-color: white;
    height: 100%;
    position: relative;
}

.bg-login {
    background: url("../assets/bg.jpg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    height: 100%;
    opacity: 0.8;
    z-index: 1;
}

.bg-login > li {
    list-style: none;
    /*display: none;*/
    position: relative;
    width: 100%;
    height: 100%;
    position: absolute;
}

.bg-login > li > img {
    width: 100%;
    height: 100%;
    opacity: 0.9;
    transition: ease .5s;
}

.login-s {
    position: absolute;
    width: 350px;
    height: 280px;
    background-color: rgba(0, 0, 0, 0.3);
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    z-index: 2;
    box-shadow: 10px 10px 20px 0px rgba(0, 0, 0, 0.7);
    text-align: center;
}

.login_form {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue